import { CETheme } from './theme.types';
import { ThemeNames } from 'utils/constants/hostConfig.constants';
import careexpandTheme from './careExpandTheme.constant';
import sonospineTheme from './sonospineTheme.constant';

type ThemeList = { [key in ThemeNames]: CETheme };
const appThemes: ThemeList = { baseTheme: careexpandTheme, sonospineTheme };

export default appThemes;
